import React, { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import "../../../Styles/Hrnav.css";
import training1 from "../../../assets/Trainingpro.png";
import ApiService from "../../../nhrc_apis/ApiService";

function TrainingProgram() {
    const navigate = useNavigate();

    const [trainingPrograms, setTrainingPrograms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchTrainings = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            console.log("━━━━ Fetching HR training programs ━━━━");

            const response = await ApiService.TrainingAPI.getHrTrainings();

            console.log("HR TRAININGS FULL RESPONSE :", response);
            console.log("HR TRAININGS DATA          :", response?.data);

            const data = response?.data;

            const list = Array.isArray(data)
                ? data
                : Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.results)
                ? data.results
                : Array.isArray(data?.trainings)
                ? data.trainings
                : [];

            console.log("PARSED TRAINING LIST :", list);

            const mapped = list.map((item) => ({
                id:       item.id          || item._id          || item.training_id || null,
                title:    item.title       || item.program_title || "Untitled",
                category: item.program_category                 || "—",
                trainer:  item.trainer_name || item.organizer_name || "—",
                mode:     item.training_mode                    || "—",
                schedule: item.start_date && item.end_date
                            ? `${item.start_date} - ${item.end_date}`
                            : item.start_date || "—",
                time:     item.start_time && item.end_time
                            ? `${item.start_time} - ${item.end_time}`
                            : "—",
                location: item.location    || "—",
                image:    item.banner_image || training1,
                shortDescription: item.short_description || "",
                capacity: item.capacity    || 0,
                contactEmail: item.contact_email || "",
                status:   item.status      || "Open",
            }));

            console.log("MAPPED TRAINING PROGRAMS :", mapped);
            setTrainingPrograms(mapped);

        } catch (err) {
            console.error("━━━━ FETCH ERROR ━━━━");
            console.error("ERROR        :", err);
            console.error("ERROR MESSAGE:", err?.message);
            console.error("ERROR STATUS :", err?.response?.status);
            console.error("ERROR DATA   :", err?.response?.data);
            setError("Failed to load training programs. Please try again.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTrainings();
    }, [fetchTrainings]);

    if (loading) {
        return (
            <section className="training-section">
                <div className="text-center mb-4">
                    <h3 className="training-title mt-5">Training Program</h3>
                </div>
                <div className="container mt-5 text-center py-5">
                    <div className="spinner-border text-danger" role="status" />
                    <p className="mt-3 text-muted">Loading training programs...</p>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="training-section">
                <div className="text-center mb-4">
                    <h3 className="training-title mt-5">Training Program</h3>
                </div>
                <div className="container mt-5 text-center py-5">
                    <p className="text-danger fw-semibold">{error}</p>
                    <button
                        className="btn btn-outline-danger mt-2"
                        onClick={fetchTrainings}
                    >
                        Retry
                    </button>
                </div>
            </section>
        );
    }

    return (
        <>
            <section className="training-section">
                <div className="text-center mb-4">
                    <h3 className="training-title mt-5">Training Program</h3>
                </div>

                {trainingPrograms.length === 0 ? (
                    <div className="text-center py-5">
                        <h6 className="text-muted">No training programs available at the moment.</h6>
                    </div>
                ) : (
                    <div className="training-grid">
                        {trainingPrograms.map((item, index) => (
                            <div className="training-card" key={item.id || index}>

                                {/* Left Content */}
                                <div className="training-info">
                                    <p><strong>Program Title :</strong> {item.title}</p>
                                    <p><strong>Program Category :</strong> {item.category}</p>
                                    <p><strong>Trainer/Host :</strong> {item.trainer}</p>
                                    <p><strong>Training Mode :</strong> {item.mode}</p>
                                    <p><strong>Schedule :</strong> {item.schedule}</p>
                                    <p><strong>Time :</strong> {item.time}</p>
                                    <p><strong>Location :</strong> {item.location}</p>
                                    <button
                                        className="training-btn"
                                        onClick={() =>
                                            navigate("/hrdashboard/TraingprogramRegistration", {
                                                state: { event: item },
                                            })
                                        }
                                    >
                                        REGISTER NOW
                                    </button>
                                </div>

                                {/* Right Image */}
                                <div className="training-img">
                                    <img
                                        src={item.image || training1}
                                        className="img-fluid"
                                        alt={item.title}
                                        onError={(e) => { e.target.src = training1; }}
                                    />
                                </div>

                            </div>
                        ))}
                    </div>
                )}
            </section>
        </>
    );
}

export default TrainingProgram;